import { useContext } from "react";
import { AppContext } from "../../../AppProvider";
import "../../../../styles/workspace_styles/CustomerUserStyles/Accounts/Profile.css";

const Profile = () =>{
    const {userProfile} = useContext(AppContext);
    return(
        <div className="customer-user-account-profile-container">
            <div className="customer-user-account-profile-header">
                <div>
                    <h1>Profile</h1>
                    <h2>{userProfile?.emailAddress || 'username unavailable'}</h2>
                </div>
                {/* <div>
                    <p>Last Login</p>
                    <p>**Last login date here**</p>
                </div> */}
            </div>
            <div className="customer-user-account-profile-body">
                <div className="customer-user-account-profile-entry-container">
                    <p>Email<span>*</span></p>
                    <input readOnly value={userProfile?.emailAddress || ''}/>
                </div>
                <div className="customer-user-account-profile-entry-container">
                    <p>First name</p>
                    <input readOnly value={userProfile?.firstName || ''}/>
                </div>
                <div className="customer-user-account-profile-entry-container">
                    <p>Last name</p>
                    <input readOnly value={userProfile?.lastName || ''}/>
                </div>
                <div className="customer-user-account-profile-entry-container">
                    <p>Country</p>
                    <input readOnly value={userProfile?.country || ''}/>
                </div>
                <div className="customer-user-account-profile-entry-container">
                    <p>City</p>
                    <input readOnly value={userProfile?.city || ''}/>
                </div>
                <div className="customer-user-account-profile-entry-container">
                    <p>Phone Number</p>
                    <input readOnly value={userProfile?.phoneNumber || ''}/>
                </div>
            </div>
        </div>
    );
};
export default Profile;